<template lang="pug">
  section
    b-container
      h1 ACCOUNT
      b-nav
        b-nav-item(:to="{name: 'AccountProfile'}") PROFILE
        b-nav-item.ml-auto(@click="logout") LOGOUT
    b-container.pt-3
      router-view
</template>

<script>
import { mapActions } from 'vuex';
import standardMix from '@/mixins/standardMix';

export default {
  mixins: [standardMix],
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
    ...mapActions('account', ['updateAccount', 'logout']),
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/views/Account.vue